import { ACTIONS } from "./adminConfig";

export default function AdminHeader({ currentSection, selectedItem, activeAction, setActiveAction }) {
	// Ne pas afficher le header pour carrousel (a son propre layout)
	if (selectedItem.id === "carrousel") {
		return null;
	}

	return (
		<header className="admin-header">
			<div className="breadcrumb">
				<span>{currentSection?.label}</span>
				<span className="crumb-sep">›</span>
				<strong>{selectedItem.label}</strong>
			</div>
			{selectedItem.id !== "dashboard" && (
				<div className="action-switcher">
					{ACTIONS.map((action) => (
						<button key={action.id} type="button" className={`pill ${activeAction === action.id ? "active" : ""}`} onClick={() => setActiveAction(action.id)}>{action.label}</button>
					))}
				</div>
			)}
		</header>
	);
}